import { FuseChangePasswordComponent } from './components/change-password/change-password.component';
import { SweetAlertService } from 'app/main/services/sweet-alert/sweet-alert.service';
import { FuseAddUserComponent } from './components/add-user/add-user.component';
import { FuseEditOrViewUserComponent } from './components/edit-or-view-user/edit-or-view-user.component';
import { IUser } from './../../../../models/users/iuser';
import { UserService } from './../../../../services/users/user.service';
import { AuthenticationService } from './../../../../services/authentication/authentication.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { fuseAnimations } from '../../../../../core/animations';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DataSource } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatDialogConfig, MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { SelectionModel } from '@angular/cdk/collections';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { User } from 'app/main/models/users/user';
import { Role } from 'app/main/models/roles/role';
import { TranslationService } from 'app/main/services/translation/translation.service';
import { GUID } from 'app/main/helpers/guid.helper';
import { environment } from '../../../../../../environments/environment';

@Component({
    selector: 'fuse-management-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    animations: fuseAnimations
})
export class FuseUsersComponent implements OnInit {

    displayedColumns = ['Photo', 'UserName', 'FirstName', 'LastName', 'PhoneNumber', 'Role', 'Actions'];
    // displayedColumns = ['select', 'userId', 'userName', 'progress', 'color'];
    userDatabase;
    userRoleId;
    dataSource: ExampleDataSource | null;
    confirmDialogRef: any;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;
    public baseUri;

    constructor(
        private userService: UserService,
        public dialog: MatDialog,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private authenticationService: AuthenticationService
    ) {
        this.baseUri = environment.baseUri;

    }

    ngOnInit() {
        this.userRoleId = this.authenticationService.getAuthData().Roles[0].Id; 
        this.userDatabase = new UserDatabase(this.userService, this.authenticationService);
        this.dataSource = new ExampleDataSource(this.userDatabase, this.paginator, this.sort);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }
                this.dataSource.filter = this.filter.nativeElement.value;
            });

    }

    add() {
        let user = new User();
        user.Id = (new GUID).toString();
        let emptyApplicationRole = new Role();
        emptyApplicationRole.Id = '';
        emptyApplicationRole.Name = '';
        user.Roles.push(emptyApplicationRole);

        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                user: JSON.parse(JSON.stringify(user))
            }
        };

        this.confirmDialogRef = this.dialog.open(FuseAddUserComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseUsersComponent > add > result', result);
            if (result != true) {
                this.userDatabase.add(result);
            }
        });
    }

    editOrView(mode: string, user: IUser) {
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: mode,
                user: JSON.parse(JSON.stringify(user))
            }
        };

        this.confirmDialogRef = this.dialog.open(FuseEditOrViewUserComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseUsersComponent > editOrView > result', result);
            if (result != true) {
                if (mode === 'edit') {
                    this.userDatabase.edit(result);
                }
            }
        });
    }

    changePassword(user: IUser) {
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                user: JSON.parse(JSON.stringify(user))
            }
        };

        this.confirmDialogRef = this.dialog.open(FuseChangePasswordComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseUsersComponent > changePassword > result', result);
            if (result != true) {
            }
        });
    }

    delete(user: IUser) {
        this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', user.FirstName + ' ' + user.LastName, (res) => {
            this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
                this.userService.delete(user.Id).subscribe(response => {
                    if (response.ResultCode == 1) {
                        this.userDatabase.delete(user);
                        this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                    } else {
                        this.translationService.translate('ERRORS.ERROR_REQUEST', response.ResultMsg, (res: string) => {
                            this.sweetAlertService.error('Error', res, null);
                        })
                    }
                }, error => {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    })
                });
            }, () => {
                console.log('FuseUsersComponent > delete > canceled');
            });
        });
    }
}

export class UserDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<IUser[]> = new BehaviorSubject<IUser[]>([]);

    get data(): IUser[] {
        return this.dataChange.value;
    }

    constructor(
        private userService: UserService,
        private authenticationService: AuthenticationService,
    ) {
        this.userService.getAllByRol(this.authenticationService.getAuthData().Id, this.authenticationService.getAuthData().Roles[0].Id).subscribe(response => {
            console.log('UserDatabase > response', response);
            if (response.ResultCode == 1) {
                for (const result of response.Result) {
                    this.add(result);
                }
            } else {

            }
        }, erro => {

        });
    }

    public add(user: IUser) {
        const copiedData = this.data.slice();
        copiedData.push(user);
        this.dataChange.next(copiedData);
    }

    public edit(user: IUser) {
        const copiedData = this.data.slice();
        let index = copiedData.findIndex(u => u.Id == user.Id);
        copiedData[index] = user;
        this.dataChange.next(copiedData);
    }

    public delete(user: IUser) {
        const copiedData = this.data.slice();
        let index = copiedData.findIndex(u => u.Id == user.Id)
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, UserDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class ExampleDataSource extends DataSource<any>
{
    _filterChange = new BehaviorSubject('');

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    filteredData: IUser[] = [];
    renderedData: IUser[] = [];
    dataLength: number = 0;

    constructor(
        private _userDatabase: UserDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort
    ) {
        super();

        // Reset to the first page when the user changes the filter.
        this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<IUser[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this._userDatabase.dataChange,
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            // Filter data
            this.filteredData = this._userDatabase.data.slice().filter((item: IUser) => {
                let searchStr = (item.FirstName + item.LastName + item.Email + item.DocumentNumber + item.UserName).toLowerCase();
                return searchStr.indexOf(this.filter.toLowerCase()) != -1 && item.UserName != 'superadmin';
            });

            // Sort filtered data
            const sortedData = this.sortData(this.filteredData.slice());

            // Grab the page's slice of the filtered sorted data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            this.dataLength = this._userDatabase.data.length;
            return this.renderedData;
        });
    }

    disconnect() {
    }

    /** Returns a sorted copy of the database data. */
    sortData(data: IUser[]): IUser[] {
        if (!this._sort.active || this._sort.direction == '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';
            switch (this._sort.active) {
                case 'UserName':
                    [propertyA, propertyB] = [a.UserName, b.UserName];
                    break;
                case 'FirstName':
                    [propertyA, propertyB] = [a.FirstName, b.FirstName];
                    break;
                case 'LastName':
                    [propertyA, propertyB] = [a.LastName, b.LastName];
                    break;
                case 'Email':
                    [propertyA, propertyB] = [a.Email, b.Email];
                    break;
                case 'PhoneNumber':
                    [propertyA, propertyB] = [a.PhoneNumber, b.PhoneNumber];
                    break;
            }

            let valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            let valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction == 'asc' ? 1 : -1);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/users/users.component.ts